import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import { useTranslations } from '../translations';
import './LegalPages.css';

interface AboutPageProps {
  isLoggedIn: boolean;
  onNavigateToLogin: () => void;
  onNavigateToRegister: () => void;
  onNavigateToHome: () => void;
  onLogout: () => void;
  onNavigateToProfile?: () => void;
  onNavigateToMyAnnouncements?: () => void;
  onNavigateToLocations?: () => void;
  onNavigateToCreateProduct?: () => void;
  onNavigateToMessages?: (productId?: string | null) => void;
  onNavigateToTerms?: () => void;
  onNavigateToPrivacy?: () => void;
  onNavigateToCookies?: () => void;
  onNavigateToContact?: () => void;
}

const AboutPage: React.FC<AboutPageProps> = ({
  isLoggedIn,
  onNavigateToLogin,
  onNavigateToRegister,
  onNavigateToHome,
  onLogout,
  onNavigateToProfile,
  onNavigateToMyAnnouncements,
  onNavigateToLocations,
  onNavigateToCreateProduct,
  onNavigateToMessages,
  onNavigateToTerms,
  onNavigateToPrivacy,
  onNavigateToCookies,
  onNavigateToContact,
}) => {
  const t = useTranslations();

  return (
    <div className="legal-page">
      <Header
        isLoggedIn={isLoggedIn}
        onNavigateToLogin={onNavigateToLogin}
        onNavigateToRegister={onNavigateToRegister}
        onNavigateToHome={onNavigateToHome}
        onLogout={onLogout}
        onProfileClick={onNavigateToProfile}
        onLocationsClick={onNavigateToLocations}
        onMessagesClick={onNavigateToMessages}
        onAnnouncementsClick={onNavigateToMyAnnouncements}
        onNavigateToCreateProduct={onNavigateToCreateProduct}
      />

      <div className="legal-content">
        <BackButton className="legal-back-button" onClick={() => window.history.back()} />
        <div className="legal-container">
          <h1 className="legal-title">{t.home.aboutTitle}</h1>

          <section className="legal-section">
            <p>
              {t.home.aboutPlatformText.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  {index < t.home.aboutPlatformText.split('\n').length - 1 && <br />}
                </span>
              ))}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t.home.aboutSellTitle}</h2>
            <p>
              {t.home.aboutSellText.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  {index < t.home.aboutSellText.split('\n').length - 1 && <br />}
                </span>
              ))}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t.home.aboutBuyTitle}</h2>
            <p>
              {t.home.aboutBuyText.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  {index < t.home.aboutBuyText.split('\n').length - 1 && <br />}
                </span>
              ))}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t.home.aboutOperatorTitle}</h2>
            <p>
              {t.home.aboutOperatorText.split('\n').map((line, index) => (
                <span key={index}>
                  {line}
                  {index < t.home.aboutOperatorText.split('\n').length - 1 && <br />}
                </span>
              ))}
            </p>
          </section>
        </div>
      </div>

      <Footer
        onNavigateToTerms={onNavigateToTerms}
        onNavigateToPrivacy={onNavigateToPrivacy}
        onNavigateToCookies={onNavigateToCookies}
        onNavigateToAbout={() => {}}
        onNavigateToContact={onNavigateToContact}
      />
    </div>
  );
};

export default AboutPage;
